'use client'

import ProductCard from "../product/ProductCard"
import { MoveRight, PackageOpen } from "lucide-react"
import EmptyState from "../elements/EmptyState"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"

export default function Products({ products, vendor, title, limit, description, viewAllUrl }: { products: any[], vendor: any, wishlist?: any, title: string, limit?: number, description?: string, viewAllUrl?: string }) {
  const pathname = usePathname()
  const displayProducts = (products || []).slice(0, limit || 8)

  return (
    <section className="w-full px-4 lg:px-6 py-12 lg:py-16">
      <div className="flex items-end justify-between gap-6 mb-6 lg:mb-8">
        <div className="min-w-0">
          <h2 className="text-2xl sm:text-4xl tracking-tight text-foreground">{title}</h2>
          {description && <p className="mt-2 text-sm text-muted-foreground">{description}</p>}
        </div>
        {viewAllUrl && displayProducts.length > 0 && (
          <a href={navigateUrl(viewAllUrl, pathname)} className="group shrink-0 inline-flex items-center gap-1.5 text-[13px] tracking-wide focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground">
            <span className="pb-0.5 bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-position-[0_100%] bg-size-[0%_1px] group-hover:bg-size-[100%_1px] transition-[background-size] duration-500 ease-out motion-reduce:transition-none">Бүгдийг харах</span>
            <MoveRight className="size-3.5" strokeWidth={1.5} />
          </a>
        )}
      </div>
      {displayProducts.length > 0 ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-1 gap-y-8 lg:gap-y-12">
          {displayProducts.map((product: any) => (
            <ProductCard key={product.customId} product={product} vendor={vendor} />
          ))}
        </div>
      ) : (
        <EmptyState icon={PackageOpen} title="Бүтээгдэхүүн байхгүй байна" description="Яг одоогоор энэ төрлийн бүтээгдэхүүн байхгүй байна. Хэсэг хугацааны дараа дахин шалгана уу.">
          <a href={navigateUrl('/product', pathname)} className="inline-flex h-11 items-center px-8 border border-foreground text-[13px] tracking-wide text-foreground transition-colors duration-150 hover:bg-foreground hover:text-background focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground">Бүх бараа үзэх</a>
        </EmptyState>
      )}
    </section>
  )
}
